import env from '../../env';
import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getAllCustomers = createAsyncThunk(
  'customers/getAllCustomers',
  async (arg, { rejectWithValue }) => {
    arg = arg === undefined ? { criteria: 'customerCode', searchValue: '' } : arg;
    let { criteria, searchValue } = arg;
    searchValue = searchValue === undefined ? '' : searchValue;
    criteria = criteria === '' ? 'customerCode' : criteria;

    try {
      const { data } = await axios.get(
        `${env.API_URL}/debitors/?filters[${criteria}][$containsi]=${searchValue}&pagination[pageSize]=10000`,
        {
          headers: {
            jwt: localStorage.getItem('microsoftJWT'),
            Accept: 'application/json',
          },
        }
      );
      return data;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  }
);

export const createDebitor = createAsyncThunk(
  'customers/createDebitor',
  async (debitorData, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`${env.API_URL}/debitors`, { data: debitorData }, {
        headers: {
          jwt: localStorage.getItem('microsoftJWT'),
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });
      return data;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? { error: { message: 'Unknown error' } });
    }
  }
);

export const updateDebitor = createAsyncThunk(
  'customers/updateDebitor',
  async ({ id, data: updateData }, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(`${env.API_URL}/debitors/${id}`, { data: updateData }, {
        headers: {
          jwt: localStorage.getItem('microsoftJWT'),
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });
      return data;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? { message: 'Unknown error' });
    }
  }
);

export const deleteDebitor = createAsyncThunk(
  'customers/deleteDebitor',
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await axios.delete(`${env.API_URL}/debitors/${id}`, {
        headers: {
          jwt: localStorage.getItem('microsoftJWT'),
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });
      return { id, res: data };
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? { message: 'Unknown error' });
    }
  }
);
